(function () {
  var SLIDESHOW_CLASS = 'ab-slideshow-video-to-image';
  var SLIDESHOW_SELECTOR = '.slideshow__slide[data-ab-test="slideshow-video-to-image"]';
  var FEATURED_CLASS = 'ab-featured-collection-bestsellers';
  var FEATURED_SELECTOR = '[data-ab-test="featured-collection-swap"]';

  function syncSlideshowVideoToImage() {
    if (!document.body.classList.contains(SLIDESHOW_CLASS)) return;

    document.querySelectorAll(SLIDESHOW_SELECTOR).forEach(function (slide) {
      slide.setAttribute('data-slide-type', 'image');

      slide.querySelectorAll('video-media').forEach(function (videoMedia) {
        if (typeof videoMedia.pause === 'function') {
          videoMedia.pause();
        }
      });
    });
  }

  function normalizeText(text) {
    if (!text) return '';

    var textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  function pushFeaturedCollectionViewItemList(panel) {
    var productList = panel.querySelector('.featured-collections__ab-variation product-list');

    if (!productList || productList.dataset.abTrackingPushed === 'true') return;

    var items = [];
    var index = 0;

    productList.querySelectorAll('product-card').forEach(function (card) {
      var link = card.querySelector('[data-product-id]');

      if (!link) return;

      index += 1;

      items.push({
        item_id: link.getAttribute('data-product-item-id') || link.getAttribute('data-product-id') || '',
        item_name: normalizeText(link.getAttribute('data-product-title') || ''),
        item_brand: link.getAttribute('data-product-vendor') || '',
        item_category: link.getAttribute('data-product-type') || '',
        item_variant: link.getAttribute('data-product-variant-title') || '',
        item_list_id: panel.getAttribute('data-list-id-variation') || '',
        item_list_name: panel.getAttribute('data-list-name-variation') || '',
        price: parseFloat(link.getAttribute('data-product-price') || '0'),
        quantity: 1,
        index: index
      });
    });

    if (!items.length) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'eec.view_item_list',
      event_name: 'view_item_list',
      event_source: 'source_code',
      ecommerce: {
        item_list_id: panel.getAttribute('data-list-id-variation') || '',
        item_list_name: panel.getAttribute('data-list-name-variation') || '',
        items: items
      }
    });

    productList.dataset.abTrackingPushed = 'true';
  }

  function syncFeaturedCollectionSwap() {
    var isVariation = document.body.classList.contains(FEATURED_CLASS);

    document.querySelectorAll(FEATURED_SELECTOR).forEach(function (panel) {
      var controlUrl = panel.getAttribute('data-url-control');
      var variationUrl = panel.getAttribute('data-url-variation');
      var nextUrl = isVariation ? variationUrl : controlUrl;

      if (nextUrl) {
        panel.setAttribute('data-url', nextUrl);
      }

      panel.querySelectorAll('.featured-collections__panel-view-all').forEach(function (link) {
        if (nextUrl) {
          link.setAttribute('href', nextUrl);
        }
      });

      if (isVariation) {
        pushFeaturedCollectionViewItemList(panel);
      }
    });

    var headerViewAll = document.querySelector('.featured-collections__header-view-all');

    if (headerViewAll) {
      var firstPanel = document.querySelector(FEATURED_SELECTOR);
      var headerUrl = isVariation
        ? firstPanel && firstPanel.getAttribute('data-url-variation')
        : firstPanel && firstPanel.getAttribute('data-url-control');

      if (headerUrl) {
        headerViewAll.setAttribute('href', headerUrl);
      }
    }
  }

  function syncAbTests() {
    syncSlideshowVideoToImage();
    syncFeaturedCollectionSwap();
  }

  syncAbTests();

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class') {
        syncAbTests();
      }
    });
  }).observe(document.body, { attributes: true });
})();
